import { useEffect, useState } from 'react';

import { DocRequirementTypes } from '../types';

export function useDocPresentStatus(
    missingDocs: DocRequirementTypes[],
    documentType: DocRequirementTypes
) {
    const [isDocPresent, setIsDocPresent] = useState(false);

    useEffect(() => {
        if (missingDocs.length === 0) return setIsDocPresent(false);

        const hasDocs = missingDocs.includes(documentType);

        setIsDocPresent(hasDocs);
    }, [missingDocs, documentType]);

    return isDocPresent;
}
